import shared from './shared'

export default {
    shared,
    async getQuizQuestions (quizKey) {
        try {
            const getQuizQuestions = this.shared.functions().httpsCallable('getQuizQuestions')
            const data = await getQuizQuestions(quizKey)
            return data.data
        } catch (error) {
            console.error(error)
        }
    }
}
